import React from 'react';

import {Card, CardContent, CardHeader, Grid, Typography} from '@mui/material';

import {Head} from '@wheeebo/polaris-ui';

function AboutPage(): JSX.Element {
  return (
    <Grid container spacing={1}>
      <Head title="About" />
      <Grid item xs={12} sm={8}>
        <Card>
          <CardHeader title="About" />
          <CardContent>
            <Typography paragraph>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas sollicitudin, ipsum non hendrerit
              posuere, massa magna iaculis nunc, vel tempor magna dui et nulla. Suspendisse eget justo eu enim molestie
              sollicitudin. Praesent rhoncus ligula sit amet augue faucibus, vitae ullamcorper est dapibus. Pellentesque
              vitae lobortis dolor. Sed a nibh at quam dapibus sollicitudin a id purus. Fusce vel placerat enim.
              Phasellus tempus enim non turpis bibendum semper. Praesent a pretium tortor. Praesent vitae nulla gravida,
              viverra enim sit amet, blandit ipsum. Ut posuere, leo sed faucibus finibus, justo massa aliquet ligula,
              quis tincidunt justo arcu nec arcu. Quisque facilisis tristique leo, sit amet venenatis elit blandit non.
              Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Proin molestie
              venenatis elit, eu sollicitudin velit blandit sed. Integer faucibus nisl in tincidunt congue.
            </Typography>
            <Typography paragraph>
              Proin interdum malesuada diam, et imperdiet nisi. Curabitur id aliquam neque. Maecenas nisi ligula,
              hendrerit sit amet tempus sit amet, scelerisque tempor libero. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Quisque ut risus vel ex ullamcorper fermentum. Donec aliquet nulla vitae nunc iaculis
              tempus. Donec aliquam lobortis dui, eget consequat sapien dictum nec. Proin sodales est eu lorem feugiat,
              consectetur luctus erat convallis.
            </Typography>
            <Typography paragraph>
              Phasellus dictum diam neque, ac mollis urna semper a. Suspendisse sollicitudin porta nisi. Quisque turpis
              risus, vestibulum sit amet fringilla vel, vulputate et leo. Maecenas tempus erat non odio elementum
              gravida. Vestibulum ac nisl felis. Ut a odio turpis. Morbi nec aliquam ex. Ut pharetra luctus semper.
              Suspendisse tristique sapien eu odio faucibus rutrum. In vehicula rhoncus lacus et tempor. Praesent mollis
              faucibus ultricies. Nullam sed mattis justo, eu accumsan lacus. Vestibulum et nulla ut nibh posuere
              dapibus. Nunc quis turpis lacus. Vestibulum quis est diam.
            </Typography>
            <Typography paragraph>
              Fusce nec luctus diam. Nulla dictum volutpat nibh non sollicitudin. Nam lacus mauris, imperdiet sed
              lobortis eget, mattis eu arcu. Nunc sagittis tincidunt commodo. Pellentesque porta auctor arcu ac
              condimentum. In pharetra nunc a venenatis aliquet. Quisque ac libero eget neque maximus molestie a vitae
              sem. Phasellus sem odio, tempor sit amet pharetra at, porta in neque. Pellentesque pulvinar lectus commodo
              auctor efficitur. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
              Sed sollicitudin urna dignissim nunc hendrerit, nec faucibus magna porta. Pellentesque ut leo ipsum. Sed
              sem nulla, convallis in convallis vel, ultrices vitae diam.
            </Typography>
            <Typography paragraph>
              Proin mollis tristique tortor nec condimentum. Donec gravida justo eget neque tempor molestie. Nulla nec
              lectus sed tortor dapibus condimentum. Aliquam consectetur, felis eget tincidunt pellentesque, purus erat
              sagittis turpis, sit amet porttitor est ex nec ante. Curabitur maximus tellus ut orci gravida molestie.
              Pellentesque vel turpis metus. Donec risus odio, bibendum quis massa ut, tincidunt feugiat enim. Aliquam
              tincidunt odio sed rhoncus tempor. Ut pellentesque tristique magna vitae venenatis. Morbi lectus augue,
              convallis sagittis est in, cursus finibus felis. Donec lacinia mi vitae ante aliquam, in aliquam erat
              fringilla. Praesent erat est, pulvinar facilisis eros in, commodo sollicitudin turpis. Nunc euismod eros
              nec lectus pharetra, vel fringilla magna hendrerit. Pellentesque ultricies elit eget ultrices placerat.
              Etiam erat mauris, dictum vitae volutpat tempus, lacinia at felis. Duis suscipit augue ut dignissim
              tristique.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default React.memo(AboutPage);
